import React, { useState, useEffect } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../../common/modal";
import api from '../../../services/axios';
import Swal from "sweetalert2";
import { blobType } from '../../../constants/appConst';
import { useJWTAuth } from '../../../services/JWTAuthProvider';

const Rename = ({ name, id, type, isOpen, closeCallback, successCallback }) => {
    const [inputValue, setInputValue] = useState(name || '');
    const [subBtnDisabled, setSubBtnDisabled] = useState(false);
    const { refreshFolders } = useJWTAuth();

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    useEffect(() => {
    if (type === blobType.File && name) {
        const lastDot = name.lastIndexOf('.');
        setInputValue(lastDot > -1 ? name.substring(0, lastDot) : name);
    } else {
        setInputValue(name || '');
    }
}, [name, type]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubBtnDisabled(true);
        setInputValue('');
        if (inputValue === "") {
            Swal.fire({
                position: "center",
                icon: "info",
                text: type + ' name is required',
                showConfirmButton: true,
                timer: 3000,
                timerProgressBar: true
            });
            setSubBtnDisabled(false);
            return;
        }
        try {
            let body = {
                name: inputValue
            };
            let endpoint = type === blobType.File ? "/files" : type === blobType.Link ? "Link/RenameLink" : "/folders"
            if (type === blobType.File) {
                body.blobGuid = id;
                body.name = inputValue + "." + name.substring(name.lastIndexOf('.') + 1)
            }
            else if (type === blobType.Folder) {
                body.folderGuid = id;
            }
            else {
                body.linkIdentifier = id;
            }
            const { data } = await api.put(endpoint, body);
            if (data.statusCode === 200) {
                if (type === blobType.Folder)
                    refreshFolders();
                if (successCallback)
                    successCallback(id);
                closeCallback();
                Swal.fire({
                    position: "center",
                    icon: "success",
                    text: 'Renamed Successfully',
                    showConfirmButton: true,
                    timer: 3000,
                    timerProgressBar: true
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setInputValue('');
        setSubBtnDisabled(false);
    }
    return (
        <Modal isLarge={false} isOpen={isOpen}>
            <ModalHeader>
                {type === blobType.File ? <h5 className="modal-title">
                    <img src="/Assets/file-icon.svg" alt="Add Files" /> Rename {type}
                </h5> : type === blobType.Folder ? <h5 className="modal-title">
                    <img src="/Assets/folder2-icon.svg" alt="Add Files" /> Rename {type}
                </h5> : <h5 className="modal-title">
                    <img src="/Assets/link.svg" alt="Add Files" /> Rename {type}
                </h5>}

            </ModalHeader>
            <ModalBody>
                <label className="folder-btm-text">Name</label>
                <input
                    type="text"
                    className="form-control folder-textbox"
                    placeholder='Enter Name'
                    value={inputValue}
                    onChange={handleInputChange}
                />
            </ModalBody>
            <ModalFooter>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeCallback}
                >
                    Cancel
                </button>
                <button disabled={subBtnDisabled} type="button" onClick={handleSubmit} className="btn btn-primary">
                    Rename
                </button>
            </ModalFooter>
        </Modal>);
};
export default Rename;